import Track, { getAnalyticsIdFromPage } from './Track';

describe('it gets the correct analytics ids from page', () => {
	afterEach(() => {
		window.dataLayer = undefined;
		window.ga = undefined;
		window.google_tag_manager = undefined;
		window.gtag = undefined;
	});
	test('get UA id legacy', () => {
		window.ga = {
			getAll: () => [
				{
					get: () => 'UA-1234'
				}
			]
		};
		expect(getAnalyticsIdFromPage()).toBe('UA-1234');
	});
	test('get UA id from tagmanager data', () => {
		window.google_tag_manager = {
			'UA-1234': 'yep'
		};

		expect(getAnalyticsIdFromPage()).toBe('UA-1234');
	});

	test('get GA4 id from datalayer', () => {
		window.dataLayer = [];
		window.gtag = function () {
			window.dataLayer.push(arguments);
		};
		window.gtag('config', 'G-12345');

		expect(getAnalyticsIdFromPage()).toBe('G-12345');
	});

	test('get GA4 id from tagmanager data', () => {
		window.google_tag_manager = {
			'G-12345': 'yep'
		};

		expect(getAnalyticsIdFromPage()).toBe('G-12345');
	});

	test('get GA4 id from datalayer', () => {
		window.dataLayer = [];
		window.gtag = function () {
			window.dataLayer.push(arguments);
		};
		window.gtag('config', 'G-12345');

		expect(getAnalyticsIdFromPage()).toBe('G-12345');
	});
});

describe('track class', () => {
	afterEach(() => {
		window.dataLayer = undefined;
		window.ga = undefined;
		window.google_tag_manager = undefined;
		window.gtag = undefined;
	});

	test('it gets the right UA GA tracker name', () => {
		window.ga = () => {};
		window.ga.getAll = () => [
			{
				get: () => 'UA-1245'
			}
		];

		const track = new Track({
			advanced: {
				analytics_integration: {
					load_analytics: true
				}
			}
		});

		expect(track.getGaTracker('send')).toBe('send');
	});

	test('it gets right right UA GA trackname when using different GA ID', () => {
		window.ga = () => {};
		window.ga.getAll = () => [
			{
				get: () => 'UA-1245'
			}
		];

		const track = new Track({
			advanced: {
				analytics_integration: {
					load_analytics: true,
					GA_TRACKING_ID: 'UA-122'
				}
			}
		});

		expect(track.getGaTracker('send')).toBe('mopinion.send');
	});
});
